import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import OpportunitiesPage from '@/components/opportunities/index_page.vue'

export default class extends Controller {
  static values = {
    payload: Object
  }

  connect() {
    this.vue = createApp(OpportunitiesPage, {
      payload: this.payloadValue || {}
    })

    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
